import '~/assets/scss/endowment-funds.scss'


import Form from '~/js/modules/form';
import getSwiperSlider from '~/js/modules/slider';

window.addEventListener(`DOMContentLoaded`, () => {
  const forms = document.querySelectorAll(`.form-b__form`);

  if (forms.length) {
    forms.forEach((form) => new Form(form));
  }

  const objectsSlider = document.querySelector(`.s-objects__slider`),
    objectsSwiperParams = {
      slidesPerView: 1.1,
      loop: false,
      autoplay: false,
      spaceBetween: 10,
      navigation: {
        nextEl: `.s-objects .slider-arrows__arrow--next`,
        prevEl: `.s-objects .slider-arrows__arrow--prev`,
        disabledClass: `disabled`,
      },
      pagination: false,
      breakpoints: {
        320: {
        },
        480: {
        },
        1024: {
          slidesPerView: 1.7,
          spaceBetween: 25,
        }
      }
    };
  if (objectsSlider) {
    getSwiperSlider(objectsSlider, objectsSwiperParams);
  }
});
